import request from '@/utils/request'

export function superadmin(email, password) {
  const data = {
    email,
    password
  }
  return request({
    url: '/superadmin/login',
    method: 'post',
    data
  })
}
export function logoutUpdate(staff) {
  if (staff.is_loggedin == undefined) {
    staff.is_loggedin = null;
  }
  const data = {
    staff_id: staff.staff_id,
    is_loggedin: staff.is_loggedin
  }
  return request({
    url: 'is-logged-in/update',
    method: 'post',
    data
  })

}


export function companyLogin(email, password, company_slug) {

  const data = {
    email,
    password,
    company_slug
  }

  return request({
    url: '/company/login',
    method: 'post',
    data
  })
}

export function staffLogin(email, password, company_slug) {

  const data = {
    email,
    password,
    company_slug
  }
  return request({
    url: '/staff/login',
    method: 'post',
    data
  })
}

export function companySignup(data) {
  return request({
    url: '/company/register',
    method: 'post',
    data
  })
}
export function adminForgot(email) {
  const data = {
    email
  }
  return request({
    url: 'admin/forgot-password',
    method: 'post',
    data
  })
}
export function companyAdminForgot(email) {
  const data = {
    email
  }
  return request({
    url: 'company/forgot-password',
    method: 'post',
    data
  })
}
export function staffForgot(email) {
  const data = {
    email
  }
  return request({
    url: 'staff/forgot-password',
    method: 'post',
    data
  })
}

export function resetPassword(users) {

  const data = {


    password: users.password,
    token: users.token,
  }
  return request({
    url: 'admin/reset-password',
    method: 'post',
    data
  })
}

export function companyResetPassword(users) {

  const data = {


    password: users.password,
    token: users.token,
  }
  return request({
    url: 'company/reset-password',
    method: 'post',
    data
  })
}
export function staffResetPassword(users) {

  const data = {


    password: users.password,
    token: users.token,
  }
  return request({
    url: 'staff/reset-password',
    method: 'post',
    data
  })
}

export function companySetpassword(data) {
  return request({
    url: '/company/set-password',
    method: 'post',
    data
  })
}

export function staffSetpassword(data) {
  return request({
    url: '/staff/set-password',
    method: 'post',
    data
  })
}

export function userSetpassword(data) {
  return request({
    url: '/user/set-password',
    method: 'post',
    data
  })
}

export function userLogin(email, password) {
  const data = {
    email,
    password
  }
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}
export function userForgot(email) {
  const data = {
    email
  }
  return request({
    url: 'user/forgot-password',
    method: 'post',
    data
  })
}
export function userResetPassword(users) {

  const data = {
    password: users.password,
    token: users.token,
  }
  return request({
    url: 'user/reset-password',
    method: 'post',
    data
  })
}

export function autoLogin(data) {
  return request({
    url: 'user-auto-login',
    method: 'post',
    data
  })
}
